<script>
import options from './SearchOverlay.options'
export default options
</script>

<template>
  <nav class="kb-search-overlay kb-burger-menu" aria-label="søgning">
    <h2 id="overlaysearchheader" class="kb-burger-menu__title">
      {{ getLabel('searchOverlayOverskrift') }}
    </h2>

    <div class="kb-general-search__input kb-search-overlay__input">
      <input
        type="search"
        aria-labelledby="overlaysearchheader"
        :placeholder="getLabel('searchOverlayPlaceholder')"
        @keydown.enter="redirectToSearchPage"
        @keydown.tab="tabTrap"
        @keyup="termInput"
        v-model="inputText"
        data-order="first"
      />
      <button
        @click="redirectToSearchPage"
        class="kb-general-search__input__button"
        title="Søg"
      >
        <svg viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9.5" stroke="#ffffff" />
          <path
            d="M16 10a6 6 0 0 0-6-6M24.768 25.89l-6.718-6.718 2.122-2.122 7.778 7.778-1.82 1.82"
            stroke="#ffffff"
          />
        </svg>
      </button>
    </div>
    <div class="kb-general-search" aria-live="polite">
      <template v-for="(result, index) in results" :key="index">
        <a
          class="kb-search-overlay__result"
          :href="searchPageUrl(result.query)"
          @keydown.tab="tabTrap"
          :data-order="results.length - 1 === index ? 'last' : index"
        >
          {{ result.query }}
          <div class="kb-ui-icon kb-ui-icon--ui-link"></div>
        </a>
      </template>
    </div>
  </nav>
</template>
